<template>
  <div>
    <b-modal
      id="compose-message"
      v-model="value"
      body-class="p-0"
      size="lg"
      no-fade
      no-close-on-backdrop
      scrollable
      @shown="initData"
      @hide="resetData"
    >
      <!-- Modal Header -->
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t('sms.modal_header') }}
        </h5>
        <div class="modal-actions">
          <feather-icon
            icon="XIcon"
            class="ml-1 cursor-pointer"
            @click="$emit('input', false)"
          />
        </div>
      </template>

      <template #modal-footer>
        <!-- Footer: Left Content -->
        <div v-if="!checkValidMessage">
          <small class="text-danger mr-1">
            {{ $t('sms.warningTextFooter') }}
          </small>
        </div>
        <div v-if="!isAllowSendMessage">
          <small
            class="text-danger"
          >{{ $t('sms.costlyWarningText') }}</small>
        </div>

        <!-- Footer: Right Content -->
        <div v-if="!smsExist || (smsExist && sms.status !== 'sent')">
          <div>
            <!-- Save draft -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              :disabled="!checkValidMessage"
              @click="sendSmsMessage('draft')"
            >
              {{ $t('sms.button_text.save_draft') }}
            </b-button>

            <!-- Send -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="ml-1"
              variant="primary"
              :disabled="!checkValidMessage || !isAllowSendMessage"
              @click="$bvModal.show('modal-confirm')"
            >
              {{ $t('sms.button_text.send') }}
            </b-button>
          </div>
        </div>
      </template>

      <div style="display: flex; flex-direction: row; padding-block: 20px; justify-content: center;">
        <b-button
          style="width: 15%; margin-right: 20px;"
          :variant="type === 'filter' ? 'info' : 'secondary'"
          @click="type = 'filter'"
        >
          Suodata
        </b-button>
        <b-button
          style="width: 15%; margin-left: 20px;"
          :variant="type === 'csv' ? 'info' : 'secondary'"
          @click="type = 'csv'"
        >
          CSV
        </b-button>
      </div>

      <!-- Modal: Body -->
      <div
        class="modal-header"
        style="border-top: 1px solid rgba(34, 41, 47, 0.05); border-bottom: 1px solid rgba(34, 41, 47, 0.05); background-color: #fff;"
      >
        <div class="w-100">
          <div v-if="type === 'filter'">
            <smart-users-map :users.sync="users"/>
          </div>
          <div v-else style="margin-top: 10px; margin-bottom: 30px;">
            <input id="fileInput" type="file" style="display: none;" @change="importUsers" />
            <b-button
              variant="secondary"
              @click="openFileExplorer"
            >
              Lataa CSV-tiedosto
            </b-button>
          </div>
          <!---<label
            for=""
            style="font-weight:bold;"
            class="mb-1"
          >
            {{ $t('sms.targets') }}
          </label>
          <b-row>
            <b-col cols="6">
              <b-form-group
                v-slot="{ ariaDescribedby }"
              >
                <b-form-radio-group
                  id="btn-radios-1"
                  v-model="status"
                  :options="[
                    { text: 'Työntekijät', value: 'accepted' },
                    { text: 'Hakijat', value: 'pending' },
                  ]"
                  :aria-describedby="ariaDescribedby"
                  name="radios-btn-default"
                  buttons
                  button-variant="outline-primary"
                  :disabled="smsExist && sms.status === 'sent'"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <v-select
                v-model="state"
                :disabled="smsExist && sms.status === 'sent'"
                :placeholder="$t('sms.place_holders.select_state')"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :label="$t('sms.role_type')"
                style="text-transform: capitalize;min-width:160px;margin-left:0!important;"
                :clearable="true"
                :options="stateOptions"
              />
            </b-col>
            <b-col cols="3">
              <v-select
                v-model="city"
                class="ml-1"
                :disabled="smsExist && sms.status === 'sent'"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                style="text-transform: capitalize;min-width:160px;margin-left:0!important;"
                multiple
                taggable
                :no-drop="true"
                :placeholder="$t('sms.place_holders.input_cities')"
                :close-on-select="false"
              />
            </b-col>
            <b-col cols="3">
              <v-select
                v-model="areas"
                placeholder="Alue"
                style="text-transform: capitalize; min-width:160px; margin-left:0 !important;"
                multiple
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :clearable="true"
                :options="areaOptions"
              />
            </b-col>
            <b-col cols="3">
              <v-select
                v-model="role"
                :disabled="smsExist && sms.status === 'sent'"
                :placeholder="$t('sms.place_holders.select_roles')"
                class="ml-1"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :label="$t('gig_page.role_type')"
                style="text-transform: capitalize;min-width:160px;margin-left:0!important;"
                :clearable="true"
                :options="roleOptions"
              />
            </b-col>
          </b-row>-->
          <b-row class="mt-1">
            <b-col>
              <span class="text-secondary">
                {{ loadingUsers ? 'Loading...' : `Viestin saajia: ${usersExits} työntekijää.` }}
              </span>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="content-preview">
            <b-form-input
              v-model="title"
              :disabled="smsExist && sms.status === 'sent'"
              :placeholder="$t('sms.place_holders.title')"
              class="title-item"
              style="margin-bottom: 20px"
              size="lg"
            />
            <b-form-textarea
              :disabled="smsExist && sms.status === 'sent'"
              :value="message"
              :placeholder="$t('sms.place_holders.message')"
              class="message-item"
              size="md"
              style="overflow-wrap: break-word; min-height: 150px; margin-bottom: 20px; padding: 0!important"
              @input="handleMessageChange"
            />
          </div>
          <template v-if="contentLength > 0">
            <div class="text-secondary">
              {{ contentLength > 0 ? `${contentLength}` : '' }} Merkkiä
            </div>
            <div class="text-secondary">
              {{ `${segmentLength} Segment${segmentLength > 1 ? 's' : ''}` }}
              <span
                class="text-muted"
                style="font-size: 11px"
              >
                (160 merkkiä per segmentti)
              </span>
            </div>
            <div class="text-secondary">
              Viestin hinta: <span
                class="text-primary"
                style="font-weight: 700"
              >
                {{ `${totalMoney} €` }}
              </span>
              <span
                class="text-muted"
                style="font-size: 11px"
              >
                (0.08€ per segmentti per viesti)
              </span>
            </div>
          </template>
        </div>
      </div>
      <!-- End Modal: Body -->
    </b-modal>
    <b-modal
      id="modal-confirm"
      ok-title="Lähetä"
      cancel-title="Peruuta"
      modal-class="modal-info"
      centered
      title="SMS massaviesti varmistus"
      @ok="sendSmsMessage('sending')"
    >
      <b-card-text>
        Olet lähettämässä viestin <b>{{ usersExits }}</b> käyttäjälle.
        <ul
          v-if="state || (city && city.length > 0) || role"
          style="margin-top: 15px"
        >
          <li v-if="state">
            Maakunta: <b>{{ state }}</b>
          </li>
          <li v-if="city && city.length > 0">
            Kaupunki: <b>{{ city.join(', ') }}</b>
          </li>
          <li v-if="role">
            Rooli: <b>{{ role }}</b>
          </li>
        </ul>
        Hinta:  <span
          class="text-primary"
          style="font-weight: 700"
        >{{ `${totalMoney} €` }}</span>
        <br>
        Haluatko varmasti lähettää SMS massaviestin?
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BFormInput, BFormTextarea, BCardText, BModal, // BFormGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import vSelect from 'vue-select'
import { fetchUserExists } from '@/shared/services/communicationService'
import SmartUsersMap from '@hw-ui/smart-components/maps/SmartUsersMap.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormTextarea,
    BCardText,
    BModal,
    // BFormGroup,
    // BFormRadioGroup,
    SmartUsersMap,

    // 3rd Party
    // vSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sms: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      type: 'filter',
      importFile: null,
      id: '',
      state: '',
      status: 'accepted',
      stateOptions: [
        'ahvenanmaa',
        'etelä-karjala',
        'etelä-pohjanmaa',
        'etelä-savo',
        'kainuu',
        'kanta-häme',
        'keski-pohjanmaa',
        'keski-suomi',
        'kymenlaakso',
        'lappi',
        'pirkanmaa',
        'pohjanmaa',
        'pohjois-karjala',
        'pohjois-pohjanmaa',
        'pohjois-savo',
        'päijät-häme',
        'satakunta',
        'varsinais-suomi',
        'uusimaa',
      ],
      areaOptions: [],
      areas: [],
      city: [],
      role: '',
      title: '',
      message: '',
      processer: {},
      usersExits: 0,
      users: [],
      loadingUsers: false,
    }
  },
  computed: {
    contentLength() {
      return this.message.length
    },
    segmentLength() {
      return Math.ceil(this.contentLength / 160)
    },
    totalMoney() {
      return (this.segmentLength * this.usersExits * 0.08).toFixed(2)
    },
    isAllowSendMessage() {
      let isAllow = true
      if (this.totalMoney > 100) {
        if (this.processer.email === 'ilmi@hoiwa.fi' || this.processer.email === 'jama.ali@hoiwa.fi') {
          isAllow = true
        } else {
          isAllow = false
        }
      }
      return isAllow
    },
    checkValidMessage() {
      if (!this.message || !this.title || !this.usersExits) {
        return false
      }
      return true
    },
    roleOptions() {
      return this.$store.state.appAccount.roles.map(role => role.label)
    },
    smsExist() {
      return this.sms && Object.keys(this.sms).length > 0
    }
  },
  watch: {
    state() {
      this.getUsersExits()
    },
    role() {
      this.getUsersExits()
    },
    city() {
      this.getUsersExits()
    },
    status() {
      this.getUsersExits()
    },
    areas() {
      this.getUsersExits()
    },
    users() {
      this.usersExits = this.users.length
    }
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser')
      .then(res => {
        const user = JSON.parse(JSON.stringify(res))
        this.processer = {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
        }
      })
    this.$store.dispatch('appAuth/fetchAreas', {accountId: this.$store.state.appAccount.selectedAccount.value.id})
      .then(res => {
        this.areaOptions = res
      })
  },
  mounted() {
    // this.getUsersExits()
  },
  methods: {
    openFileExplorer() {
      document.getElementById('fileInput').click()
    },
    importUsers(e) {
      // eslint-disable-next-line prefer-destructuring
      this.importFile = e.target.files[0]

      try {
        if (e.target.files[0].type !== 'text/csv') {
          return
        }
        // eslint-disable-next-line prefer-destructuring
        this.importFile = e.target.files[0]
        
        const reader = new FileReader()
        reader.onload = async event => {
          const data = event.target.result
            .replaceAll('\x85', 'Ö')
            .replaceAll('\x9A', 'ö')
            .replaceAll('\x80', 'Ä')
            .replaceAll('\x8A', 'ä')
            .split('\n').filter((item, index) => item !== "" && index > 0)
            .map(item => item.split(';'))
          const users = data.map(item => ({
            id: `${item[0].slice(0, 1).toUpperCase()}${item[0].slice(1).toLowerCase()}`,
            mobile: `358${item[1]}`,
          }))

          this.users = users
          this.usersExits = users.length
          this.importFile = null
        }
        reader.readAsText(this.importFile, 'ISO-8859-4')
      } catch (err) {
        this.importFile = null
        console.error(err)
      }
    },
    getUsersExits() {
      this.loadingUsers = true
      fetchUserExists({
        state: this.state,
        city: this.city.map(c => c.toLowerCase()),
        role: this.role,
        status: this.status,
        areas: this.areas.map(area => area.value),
      })
        .then(users => {
          this.usersExits = users.length
          this.users = users[0].length === undefined ? [] : users.map(item => ({id: item[0].id, mobile: item[0].mobile}))
        })
        .catch(err => {
          throw err
        })
        .finally(() => {
          this.loadingUsers = false
        })
    },

    sendSmsMessage(status) {
      this.$emit('input', false)
      const form = this.type === 'filter'
        ? {
          message: this.message,
          status,
          title: this.title,
          publisher: `${this.processer.firstName} ${this.processer.lastName}`,
          category: 'sms',
          type: 'sms',
          target: {
            state: this.state,
            role: this.role,
            city: this.city.map(c => c.toLowerCase()),
            status: this.status,
            areas: this.areas.map(area => area.value),
          },
          contentLength: this.contentLength,
          segmentLength: this.segmentLength,
          price: this.totalMoney,
        } : {
          message: this.message,
          status,
          title: this.title,
          publisher: `${this.processer.firstName} ${this.processer.lastName}`,
          category: 'sms',
          type: 'sms',
          contentLength: this.contentLength,
          segmentLength: this.segmentLength,
          price: this.totalMoney,
        }
      this.$emit('save', {
        form,
        id: this.id,
        users: this.users,
        type: this.type
      })
      
      this.resetData()
    },

    initData() {
      if (this.smsExist) {
        const {
          id, title, message, target,
        } = this.sms
        const {
          state, role, city, status, areas,
        } = target
        this.id = id
        this.title = title
        this.message = message
        this.state = state
        this.role = role
        this.city = city.map(c => c.toLowerCase())
        this.status = status
        this.areas = areas
      }
    },

    resetData() {
      this.id = ''
      this.state = ''
      this.city = []
      this.areas = []
      this.role = ''
      this.title = ''
      this.message = ''
      this.status = 'accepted'
      this.users = []
    },

    isGSMAlphabet(text) {
      const gsm = "@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}\\ \\[~]|€ÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"

      return gsm.indexOf(text) !== -1
    },

    handleMessageChange(val) {
      const newString = []
      for (let i = 0; i < val.length; i += 1) {
        if (this.isGSMAlphabet(val.charAt(i))) {
          newString.push(val.charAt(i))
        }
      }
      this.message = newString.join('')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/sms-form.scss';
</style>
